import React from "react";
import { Helmet } from "react-helmet";
import Hero from "../../components/hero/Hero";

const Home = () => {
  return (
    <div className="home">
      <Helmet>
        <meta charSet="utf-8" />
        <title>صيانه جنرال هوم</title>
        <link rel="canonical" href="https://generalhome.sa" />
      </Helmet>
      <Hero />
    </div>
  );
};

export default Home;
